import ShowMoreComponent from './show-more.component';
import * as ShowMoreActions from './show-more.actions';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import { connect } from 'react-redux';
import { ABOUT_SERIES_TRACKING } from '@medscape-promo/medscapetv/omniture-tracking';
const { mmodule } = ABOUT_SERIES_TRACKING;


const mapStateToProps = (state, ownProps) => {

    const props = Object.assign({}, ownProps, {
    	"expand": state.WebView.isMobile === false || state.ShowMore.expand,
        "isIframe": state.WebView.isIframe
    });

    return props;
};

const mapDispatchToProps = dispatch => {
    return {
        onExpand: (linkEl) => {
        	dispatch(ShowMoreActions.expand());
            dispatch(WebViewActions.omnitureTracking(mmodule.expand, linkEl));
        },
        onCollapse: (linkEl) => {
        	dispatch(ShowMoreActions.collapse());
            dispatch(WebViewActions.omnitureTracking(mmodule.collapse, linkEl));
        }
    }

};

export default connect(mapStateToProps, mapDispatchToProps)(ShowMoreComponent);